import { NightsInfo } from './NightsInfo';

export default NightsInfo;
